import { types } from 'mobx-state-tree';

export interface SimpleTableHeadRowItemProps {
  id: number;
  caption: string;
}

export const SimpleTableHeadRowItem = types.model({
  id: types.number,
  caption: types.string,
});
